export default {
  bank: "往来款交易",
  winlose: "赢/输",
  balance: "结余",
  win: "赢",
  lose: "输",
  tie: "和",
  history: "过往记录",
  transfer_details: "转款详情",
  id: "标识",
  game: "游戏",
  contactus: "联系处",
  join_now: "马上加入",
  manual_deposit: "手动存款",

  aboutus: "关于我们",
  attention: "注意事项",
  amount_currency: "最低 ({currency} 额: {min} 最该额: {max})",
  all: "全部",
  amount: "数额",
  approved: "已批",
  and: "和",
  atm_cash: "自动柜员机/现金存款机 (ATM/Cash Deposit)",
  account_name: "银行户名",
  account_no: "银行账号",
  amount_min: "最低额",
  amount_max: "最高额",
  amount_not_min: "所录入的数值未能达到最低数额要求。",
  add_bank: "添加银行",
  account_id: "账户标识",
  adjustment_details: "信息调整",
  after_balance: "结余之后",
  android: "安卓版",
  atm: "自动柜员机 (ATM)",
  acc_detail: "账户详情",
  about_us:{
    headline: "EPICWIN - 同业唯一 #1 个为你个人资金保驾护航的殿堂级品牌",
    headlineContent_1: "欢迎你加入EpicWin，这是一个极富传奇色彩的娱乐游戏平台，它能为你带来神奇无比且会彻底颠覆游戏胜利规则的投注体验！",
    headlineContent_2: "我们期待一个个敢于尝鲜的玩家们光临我们的游戏平台。何不亲临体验我们到底能为你带来究竟有多奇妙的游戏投注体验呢？！",
    box_one:{
      title: "所有业务皆由一家字号一手包办",
      content_1: "所有与EPICWIN业务相关的运营流程、研发作业、构思设计与客服支援皆由我们的专业管理团队一手操办",
    },
    box_two:{
      title: "极速存取款",
      content_1: "加速审核流程，1分钟内完成存取款程序",
    },
    box_three:{
      title: "带给你极致游戏快感",
      content_1: "我们所研发的世界级精品游戏具备能不断吸引玩家回流，畅享更大的胜利喜悦的高额赔付机制",
    },
    box_four:{
      title: "EPICWIN价值优势，诱惑十足",
      content_1: "在无需经过代理/中介人抽成的情况下，我们能给予玩家们更多不同形式的奖励 - 更丰厚的赔付奖金，额外游戏环节和仅限会员参与的优惠活动",
    },
    swiperbox_one:{
      title: "#1 的老虎机游戏缔造者",
      highlight: "超过120",
      detail: "款赔付率高的精品老虎机游戏 (游戏正在陆续添加中)",
      mobile: "超过120款"
    },
    swiperbox_two:{
      title: "大腕级老虎机游戏的缔造者",
      detail: "节奏紧凑的影游互动游戏与贴近时下热点的游戏主题",
    },
    swiperbox_three:{
      title: "EPICWIN 注册人数",
      highlight: "480,000人次",
      detail: "自2018年3月18日算起迄今已达",
      mobile: "480,000人次"
    },
    swiperbox_four:{
      title: "EPICWIN 累计流水",
      highlight: "2.35亿令吉",
      detail: "自2018年3月18日以来已成功派送出",
      mobile: "2.35亿令吉"
    },
    swiperbox_five:{
      title: "真人直播有奖秀",
      highlight: "60,000令吉的惊人奖励会以彩金形式派送出去",
      detail: "高达",
      mobile: "60,000令吉"
    },
    swiperbox_six:{
      title: "EPIC 传媒",
      detail: "一个可让本地奇才秀出各自风采的#1真人娱乐平台"
    },
    swiperbox_seven:{
      title: "集三大伙伴于一身",
      highlight: "2021年3月18日",
      detail: "EpicWin 周年里程碑"
    },
    swiperbox_eight:{
      title: "EPICWIN联盟需要你的力量",
      highlight: "EPICWIN联盟",
      detail: "欢迎加入到玩家联盟，一个让你感到宾至如归且充满互助和共融的温馨大家庭",
      mobile: "EPICWIN联盟"
    },
  },
  amount_receive: "已收金额",
  active_player: "活跃玩家总数",
  affiliate_code: "代理链接",
  admin: "管理员",
  admin_open: "如果您收不到TAC短信验证码,请联络我们的客服",
  affiliateUI: {
    title: "代理计划",
    title1: "为何加入我们？",
    detail: "返现奖金高达50%",
    detail1: "终生收入",
    detail2: "付款保证",
    button: "加入我们即可赚取属于你的返现奖金",
    step:{
      title: "如何运作",
      detail: "赚钱公式很简单。我们提供一条追踪链接给你用于进行推广，之后你的工作就完成了。",
      step1: "注册",
      step2: "使用追踪链接开始推广",
      step3: "获取上不封顶的返现奖金"
    },
    cashback:{
      title: "返现奖金结构",
      detail: "返现奖金源于总累积输赢注额，也就是由通过你的追踪链接进行注册的玩家所生成之投注净收。",
      one: "投注净收 ≤ RM 20,000",
      two: "投注净收  RM 20,001 - RM 40,000",
      three: "投注净收  RM 40,001 - RM 60,000",
      four: "投注净收 ≥ RM 60,001",
      button: "加入我们即可赚取属于你的返现奖金"
    }
  },
  artist:{
    title: "EPIC 明星玩家",
    mainintro1: "EpicWin 非常荣幸能邀请到 Danny Chan 陈国坤",
    maindesc1: "来自<strong>香港的武打巨星</strong>成为2020年的 EpicWin 品牌大使",
    artist_content1: "<strong>陈国坤先生</strong>因动作, 神情与气质都神似武打传奇李小龙被观众们熟知, 他在《叶问4》与《功夫》等卖座电影中的精彩演出更是奠定了他新一代武打巨星的地位！",
    watch_button1: "观看陈国坤的视频",
    mainintro2: "除此之外，我们也想为您介绍3位来自大马的 Epic 明星玩家",
    maindesc2: "大马知名 Youtuber 3P、漂移女神 Leona Chin 和世界级 DJ Rachel B！",
    artist_content2: "<strong>Rachel B</strong>因活力四射的演出深受乐迷喜爱，甚至被列入为马来西亚的顶级 DJ！",
    watch_button2: "观看 Rachel B 的视频",
    artist_content3: "如果您是 YouTube 的忠实用户，您可能对他们的面孔感到熟悉，因为他们一直以创意且搞笑的视频而闻名！",
    watch_button3: "观看 ThreeeP 的视频",
    artist_content4: "<strong>Leona Chin</strong>也许是您见过最具胆识, 速度与激情的邻家女孩，这些特质也令她一跃成为大马最负盛名的美女赛车手！",
    watch_button4: "观看 Leona Chin 的视频",
  },
  attachment: "附件",

  bank_accname: "银行户名",
  bank_accno: "银行账号",
  bank_name: "银行名称",
  bank_detail: "银行详情",
  bet_history: "下注记录",
  bank_account: "银行账户",
  better_luck: "祝你下次好运些！",
  birthday: "生辰",
  bonus_details: "彩金详情",
  before_balance: "结余之前",
  bonus_value: "彩金值",
  bonus: "彩金",
  brand: {
    vision: "品牌愿景",
    vision_desc: "打造一个让诈骗活动无所遁形的游戏世界。成为业界累积大奖过账速度最快的老虎机游戏开发商。",
    purpose: "品牌使命",
    purpose_desc: "杜绝一切诈骗活动，使得每个玩家获得累积大奖的心愿得以成真。"
  },
  back: "返回",
  bonus_welcome: "欢迎奖金",
  bonus_referral: "推荐奖金",

  cdm: "现金存款机 (CDM)",
  counter: "柜台取款",
  cancel: "取消",
  change_password: "更换登录密码",
  confirm_password: "取消登录密码",
  close: "结束",
  claim: "申领",
  claim_now: "马上申领",
  current_balance: "现有结余",
  cash_deposit: "现金存款",
  contact_for_bank: "请联系EpicWin在线客服",
  congratulations: "祝贺你！",
  contact_number: "联系号码",
  claim_rewards: "申领奖励优惠",
  cash_value: "现金值",
  customer_review: "EPIC评帖",
  claim_offer: "申领属于我的优惠礼遇！",
  custom_description: {
    free_spin: "50令吉 - 99令吉 + 1张积宝券",
    free_spin2: "100令吉 - 199令吉 + 3张积宝券",
    free_spin3: "200令吉 - 499令吉 + 7张积宝券",
    free_spin4: "500令吉 - 999令吉 + 10张积宝券",
    free_spin5: "≥1000令吉 + 13张积宝券",
    free_spin6: "5000令吉 - 9999令吉 + 25次高级免费旋转",
    free_spin7: "≥10000令吉 + 50次高级免费旋转",
    free_spin8: "≥10000令吉 + 100次高级免费旋转和14张积宝券",
    get_freespin: "你获得了 {amount} 次免费旋转",
    get_premiumspin: "你获得了 {amount} 次高级免费旋转",
    get_freespin_ticket: "你获得了 {amount} 次免费旋转和 {t_amount} 张幸运抽奖券",
    get_premiumspin_ticket: "你获得了 {amount} 次高级免费旋转和 {t_amount} 张幸运抽奖券",
    get_jackpot_ticket: "你将获得 {amount} 积宝券",
    get_euroticket: "你将获得 {amount} 张欧冠活动券",
    comment_placeholder: "留下你的游戏感言",
    review_header: "推荐一位玩友即可获得内荐奖金 ",
    refer_info: "每当你所推荐的玩友存入30令吉，你就可获得 <strong> 8次免费旋转</strong> 。",
    review_text: "你的友人手机号码:",
    review_complete_header: "感谢你为我们传递了满满的正能量！",
    review_complete_text: "我们将会善用之来改善游戏品质。",
    home_title: "1分钟内完成存取款程序",
    home_description: "老虎机游戏缔造者带来#1 存取款到账时间最快的流程",
    home_title2: "累积奖金极速返奖",
    home_description2: "业内累积奖金返奖速度最快的游戏平台",
    home_title3: "大腕级老虎机游戏",
    home_description3: "我们的游戏改编自: DC、漫威、迪斯尼和 20世纪影业",
    home_title4: "无需通过代理",
    home_description4: "我们乃是一家无需代理经手的游戏品牌直营平台"
  },
  count: "人数",
  click_here: "点击这里",
  change: "转换",
  change_content:{
    mobile_title: "CHANGE TO WIN, CHANGE TO EPIC",
    title: "为何你需要转换到EPICWIN?",
    description: "EpicWin乃是一家对游戏制作充满热情的大腕级老虎机游戏之缔造者，与多家重量级电影企业比如，DC漫画, 漫威影业和迪斯尼展开强强联合。派送出在大马额度最高的线上累积奖池， EpicWin乃是首家一家无需代理经手的大腕级老虎机游戏缔造者。在EpicWin畅享尊荣待遇，保证在1分钟内完成存取款程序！",
    check_story: "查看详情",
    step: "步骤",
    step1_title: "转换成 EpicWin",
    step1_description: "从其他游戏平台",
    step1_description1: "转换至 EpicWin",
    step2_title: "录制视频",
    step2_description: "自录一段讲述自身为何转换",
    step2_description1: "至 EpicWin 的短片视频",
    step3_title: "赢取奖励",
    step3_description: "将自制的短片视频上传至脸书，",
    step3_description1: "提交视频链接就可获得丰富的奖励！",
    video_title: "转换至Epic, 获取丰富的奖励",
    small_label: "Facebook 短片链接",
    placeholder: "请输入Facebook 短片链接",
    tnc1: "优惠期限：从2020年12月1日开始截至2021年1月31日为止。",
    tnc2: "只需遵照以上所述的步骤来提交你自制的短片视频链接，即可获得活动参与资格。",
    tnc3: "一旦参与者所提交的短片视频链接经确认无误后，EpicWin将会在24小时内派送出免费旋转作为奖励。",
    tnc4: "每位参与者只限在本活动进行期间赢取一份奖励而已。",
    mobile_desc: "EpicWin是一家大腕级老虎机游戏之缔造者，并与多家重量级电影企业如，DC漫画, 漫威影业和迪斯尼展开协作。",
    mobile_desc1: "线上累积奖池派彩额当属大马最高。",
    mobile_desc2: "业内#1家直营且无需代理的老虎机游戏缔造者，保证在1分钟内完成存取款程序！"
  },
  coupon: "优惠券",

  deposit: "存款",
  deposit_enter: "请录入存款额",
  deposit_method: "存款方式",
  deposit_method_select: "请任选其中一种存款方式",
  deposit_reminder: "我已经阅过，理解并同意受所有与彩金奖励和/或提现要求",
  deposit_reminder_two: " 有关的活动规定和条款细则所约束。",
  download: "下载",
  download_android: "下载安卓版",
  download_ios: "下载苹果版 (iOS)",
  date: "日期",
  done: "完成",
  deposit_now: "马上进行存款",
  description: "说明",
  download_1: "快来加入我们的行列吧！欢迎您成为EPIC大家庭的一员",
  download_2: "您的EPIC征途从此开始！",
  deposit_tnc: "存送奖励 - 免费积宝券",
  developer_response: "开发商意见反馈",
  daily_update: "每日更新",
  downloadgame: "下载游戏",
  duitnow:{
    desc1: "最低存额: ",
    desc1_1: "30令吉",
    desc2: "保存转款收据",
    desc3: "通知线上客服专员以领取游戏币",
    desc4: "畅享我们的游戏！"
  },
  dailycheckin: "每日签到",
  deposit_topten: "排名前10存款次数",
  demoplay: "试玩",
  deposit_page:{
    reminder1: "存款前余额必须低于RM1，否则将适用之前的优惠条规",
    reminder2: "请勿使用已保存的二维码，请仅使用最新显示的二维码"
  },

  email: "电子邮箱",
  enter_bank_accname: "请录入银行户名",
  enter_bank_accno: "请录入银行账号",
  eta: "预估运行时间",
  epic_production: "EPIC Production",
  expiry_date: "最后生效日期",

  female: "女性",
  failed: "失败",
  forgot_password: "忘记登录密码？",
  faq: "常见问题",
  footer: {
    title: "呼召所有的尊荣级玩家们：无论你是想豪赌一把，纯享游戏乐趣；为了打发时间亦或寻找刺激感，并打算寻找一家信誉可靠的真人娱乐城平台，EpicWin 必能让你乘兴而来，兴尽而返。",
    description: "欢迎您来到 EpicWin, 最潮流先进的马来西亚线上老虎机游戏平台，不仅可以试玩游戏，而且只需注册开户就可领取免费游戏币 (只需完成注册程序就可获得免费游戏币), 彩金奖励, 当然您亦可以畅玩到你根本无法在其他马来西亚游戏平台里找到的优质老虎机游戏。",
    description1: "在你开始赢得大奖之前，千万别忘了\"点击领取免费游戏币链接\" 领取EpicWin新玩家专属的迎新奖励，凭着独家的游戏体验金和老虎机游戏平台踏上娱乐游戏之旅。从即日起，只需注册开户即可领取免费游戏币赢得胜利!  ",
    description2: "在EpicWin 创建账户，就可获得免费游戏币，玩转全马最顶级的老虎机游戏。无须充值，就可在EpicWin，全马最顶级的游戏平台领取免费游戏币，让您实现赢奖梦想!  ",
    description3: "EpicWin 是马来西亚顶级的线上老虎机游戏平台，提供老虎机游戏免费游戏币等超酷福利。 这是一个可让你美梦成真的游戏平台——免费注册，领取免费游戏币，开始您的 EPIC 制胜之旅！",
  },
  for_android: "供安卓版下载",
  for_ios: "供 苹果版 (iOS) 下载",
  find_out: "更多详情",
  file_choose: "点选文件",
  file_upload: "上传文件",
  file_requirement: "文件大小不得超过 1mb且必须PNG,JPG或JPEG格式",
  full_name: "全名",
  fill_stars: "请在进行下一步骤前为我们进行评估",
  fish:"钓鱼",

  gender: "性别",
  game_play: "游戏介绍",
  game: "游戏",

  hi: "嗨, ",
  has_won: "刚刚赢取了",
  has_won_rate: " 胜率",
  has_withdraw: "已提款",
  has_deposit: "已存款",
  homepage: {
  header1: "诺瓦麦提克 (NOVOMATIC) 正版老虎机游戏",
    desc1: "畅玩由领先同业的游戏产业巨头所带来的精品老虎机游戏！",
    header2: "排名争霸榜",
    desc2: "与志趣相投的玩友们在以老虎机游戏为主题的排名争霸榜和竞赛中各凭本事，一较高下！",
    header3: "丰厚的彩金奖励！",
    desc3: "畅享多样化特色优惠活动所带来的诱人彩金奖励！",
    header4: "尊享俱乐部与忠诚奖励计划",
    desc4: "让我们为你铺上红地毯，欢迎你的加入！身为一名尊荣级玩家，你可享有各式各样的尊享特权。"
  },
  hourly_update: "每小时更新",
  hot_movie: "热门电影",
  
  ios: "苹果 (iOS)",

  jackpot: "积宝",

  leaderboard_title: "排行榜前15位累计最多神奇转数的玩家",
  login: "登录",
  logout: "登出",
  login_now: "马上登录",
  lucky_spin: "参与幸运转盘赢取高达 {value} 令吉奖金奖励",
  latest_transactions: "最近交易记录",
  lucky_wheel: "幸运转盘",
  loyalty_points: "忠诚积分",
  last_4_digits: "手机号码最后的四位数",
  last_login: "最后一次登录",
  lang_en: "英文",
  lang_zh: "中文",
  lang_my: "巫文",
  luckydraw_announcement: "每当完成存款后，你将可获得幸运抽奖券<br>敬请期待直播幸运抽奖活动<br>2021年4月19日，傍晚7时30分",
  language:{
    en: 'en',
    zh: 'zh-cn',
    my: 'ms'
  },
  later: "待会",
  leaderboard: "排行榜",
  live:"赌场",
  livecasino:"在线赌场",
  live_trans: "实时交易",
  lottery: "彩票",

  male: "男性",
  mobile: "移动设备",
  minigames: "迷你游戏",
  method: "方式",
  min: "最低",
  min_amount: "最低限额",
  monthly_update: "每月更新",
  movies: "电影",
  movie_watch: "按此观看",
  marquee:{
    notice: "提醒:",
    announcement: "如果无法进入{url}，请使用 <b style='color:#FFC000'>www.epicwin.asia</b> 享受顺畅的游戏体验! 💰100% GUARANTEED CUCI !"
  },
  more_info: "查看更多",
  minigame:"迷你游戏",

  name: "姓名",
  next: "下一步",
  new_password: "全新登录密码",
  no_account_yet: "尚未注册开户？",
  no_win: "很抱歉，你未能在本轮游戏里赢得任何奖励 :(",
  nickname: "昵称",
  next_update_time: "下一次更新时间",
  no_bonus_found: "查无任何彩金详情",
  no_adjustment_found: "查无任何信息调整",
  no_new_gifts: "没有新赠礼",
  no: "序号.",
  no_contact: "查无任何联系号码！",
  no_new_message: "没收到新信息",
  newsletter: "我想通过电邮、信息或帖子获知最新的奖励与优惠活动.",
  news: "消息",

  offical_team: "官方团队",
  online: "在线",
  online_banking: "网银支付",
  online_banking_set: "网银 ({bank})",
  option: "可选择 {0}",
  optional: "可选项",
  old_password: "原先登录密码",
  ok: "好的",
  current_password: "现用登录密码",
  operator_bank_list: "运营方银行列表",
  promotion_selected: "已选定的优惠活动",

  pending: "待定",
  play_now: "开始游戏",
  partner: "合作伙伴",
  partner_short: "独家伙伴",
  partner_title: "EpicWin 独家伙伴:",
  password: "登录密码",
  password_signup: "登录密码",
  phone_number: "手机号码",
  promotion: "优惠活动",
  promotions: "诸多优惠活动",
  promotion_select: "请选择参与优惠活动 / 不参与任何优惠活动",
  profile: "账户档案",
  privacy_policy: "隐私政策",
  privacy_statement: "隐私声明",
  password_tips:"创建一组你专属的登录密码。密码必须由至少6-20 个字符组成且得包含数字与大小写字母。",
  phone_tips: "只限还在使用的有效手机号码而已，譬如：0109471427，无需空格",
  problem_contact:"如果你尚未收到讯息鉴别码，请通过即时聊天系统联系我们，予以处理。",
  reset_tips: "请录入你手机号码最后的四位数。",
  prev: "上一步",
  please_select: "请选择",
  please_select_bank: "请选择任一银行",
  please_select_payment: "请选择付款方式",
  progress : "进度",
  promotion_bonus: "优惠奖励",
  promotion_details: "优惠活动详情",
  phone_no_reminder_recipient: "请录入接收者的手机号码",
  phone_recipient_same: "接收者号码不得与发送者号码相同。",
  promo_select: "请选择参与任一优惠活动",
  promo_none: "不参与任何优惠活动",
  promo_text:{
    promo1: {
      title1: "存款额:",
      details1: "30令吉",
      title2: "初始结存:",
      details2: "36令吉",
      title3: "提现额:",
      details3: "108令吉"
    },
    promo2: {
      title1: "存款额:",
      details1: "10令吉",
      title2: "初始结存:",
      details2: "20令吉",
      title3: "提现额:",
      details3: "50令吉"
    },
    promo3: {
      title1: "存款额:",
      details1: "10令吉",
      title2: "奖金金额:",
      details2: "12令吉",
      title3: "提现额:",
      details3: "88令吉"
    },
    promo4: {
      title1: "存款额:",
      details1: "10令吉",
      title2: "初始结存:",
      details2: "11令吉",
      title3: "提现额:",
      details3: "33令吉"
    },
    promo5: {
      title1: "存款额:",
      details1: "50令吉",
      title2: "初始结存:",
      details2: "62.5令吉",
      title3: "提现额:",
      details3: "187.5令吉"
    },
    promo6: {
      title1: "出席率:",
      details1: "累计5天",
      title2: "累计存款金额:",
      details2: "150 令吉",
      title3: "奖金金额:",
      details3: "10 令吉"
    },
    promo7: {
      title1: "领取频率:",
      details1: "每天一次",
      title2: "收到百分比:",
      details2: "10%",
      title3: "提现要求:",
      details3: "x 1"
    },
    promo8: {
      title1: "存款额:",
      details1: "50令吉",
      title2: "初始结存:",
      details2: "57.5令吉",
      title3: "提现额:",
      details3: "172.5令吉"
    },
    promo9: {
      title1: "奖金金额:",
      details1: "20令吉",
      title2: "提现要求: ",
      details2: "获胜额 x3",
      title3: "红包:",
      details3: "8令吉"
    },
    promo10: {
      title1: "奖金金额:",
      details1: "20 令吉",
      title2: "累积总额: ",
      details2: "150 令吉"
    },
    promo11: {
      title1: "存款额:",
      details1: "30令吉",
      title2: "奖金金额",
      details2: "36令吉",
      title3: "提现要求: ",
      details3: "流水额 x30",
    },
    promo12:{
      title1: "存款额:",
      details1: "30令吉",
      title2: "奖金金额",
      details2: "4.5令吉",
      title3: "提现要求: ",
      details3: "流水额 x20",
    },
    promo13:{
      title1: "存款额:",
      details1: "50令吉",
      title2: "奖金金额",
      details2: "12.5令吉",
      title3: "提现要求: ",
      details3: "流水额 x20",
    },
    promo14:{
      title1: "存款额:",
      details1: "1111 令吉",
      title2: "奖金金额",
      details2: "33 + 赢取1111 令吉",
    },
    promo15:{
      title1: "奖金金额:",
      details1: "20 + 30 令吉",
      title2: "累积总额",
      details2: "500 令吉",
    },
    promo16:{
      title1: "红包:",
      details1: "500 令吉",
      title2: "获胜额",
      details2: "x10",
    },
    promo17:{
      title1: "红包:",
      details1: "33 令吉",
      title2: "获胜额",
      details2: "x4",
    },
  },
  promo_detail:{
    general_tnc: "<p>常规规则与条件</p><ul><li>每日提款次数限制为5次</li><li>Epicwin保留冻结会员账户的拥有权，若是违反条规，将不会另行通知</li><li>最低提款金额为RM10</li></ul>",
    general_tnc_casino:"<p>GENERAL TERMS &amp; CONDITIONS</p><ul><li>如果玩家违反条款和条件，将扣除赢取的余额并退还存款</li><li>奖金和赢取的余额将在30天后失效（安全目的）</li><li><span class='text-danger'>Live Casino CANNOT play - Sports / Blackjack 21 / Texas Hold'em /（ Not Include Sport Book, Fishing , RNG table ,  Slot Game )</span></li></ul>",
    promo1:{
      title: "20% 首次存款奖励 【每周一至周五】",
      table:{
        header1: "存款金额",
        header2: "獎金金額",
        header3: "起始金额",
        header4: "提现要求",
        header5: "最低提款额",
        header6: "最高提款额（6x 存款金额）",
        withdraw_req: "获胜额 x3"
      },
      tnc1: "最低存款限制为RM30，最高奖金为金额RM30",
      tnc2: "该促销活动只适于在 Epicwin & MegaH5 老虎机进行游戏，仅限每周一至周五以及每日只能领取一次",
      tnc3: "提款金额需达到3倍（存款 + 獎金金額）",
      tnc4: "提款后所有余额将从玩家的游戏账户删除",
    },
    promo2:{
      title: "电信 PIN 充值欢迎奖金：100% - Epicwin & Mega H5 独家专享",
      table:{
        header1: "存款金额",
        header2: "獎金金額",
        header3: "起始金额",
        header4: "提现要求",
        header5: "最低&最高提款额（5x 存款金额）",
        withdraw_req: "流水额 x10"
      },
      tnc1: "最低存款限制为RM10，最高奖金为金额RM50",
      tnc2: "该促销活动仅适合用于Epicwin和Mega H5新会员的首次存款",
      tnc3: "提款金额需达到10 倍（存款 + 獎金金額）的流水数额",
      tnc4: "该促销活动的最大提款金额为存款的5倍以及仅限一次，提款后所有余额将从玩家的游戏账户删除",
      tnc5: "除了Epicwin独家游戏，任何在于其他提供商处进行的投注也被计算为无效以及会员所赢取的余额将会被删除"
    },
    promo3:{
      title:"欢迎奖金 120%",
      table0:{
        header1: "欢迎奖金 120%",
        header2: "最低存款额",
        header3: "最高奖金额",
        header4: "提现要求",
        header5: "最高提款额",
        row1: "第一次存款"
      },
      table:{
        header1: "存款",
        header2: "奖金金额",
        header3: "起始金额",
        header4: "提现要求",
        header5: "最低提款额",
        withdraw_req: "获胜额 x4",
      },
      content1: "例如 : ",
      content2: "<span class='text-danger'>存款</span> 100 <span class='text-danger'>+ 奖金</span> 120 <span class='text-danger'>= 220</span>",
      content3: "最低提款额 :",
      content4: "220 x 4 = 880",
      content5: "最高提款额 :",
      content6: "100 x 10 = 1000",
      content7: "提款后，任何剩余的余额将从玩家账户中移除。",
      tnc1: "此促销的最低存款为 RM10，最高奖金为 RM120。",
      tnc2: "此促销仅适用于在 EpicWin 首次存款的新会员。",
      tnc3: "奖金适用于所有老虎机游戏。",
      tnc4: "最高提款金额为存款金额的 10 倍。",
      tnc5: "此促销不适用于真人娱乐场、体育博彩和捕鱼游戏。",
      tnc6: "除非另有说明，否则此促销不能与其他促销活动同时使用。",
      tnc7: "提款后，任何剩余的余额将从玩家账户中移除。",
      tnc8: "如果会员在奖金发放后的 30 天内未达到流水要求，所有奖金和赢款将被取消。",
      tnc9: "此促销仅限新玩家作为欢迎礼金领取一次。",
      tnc10: "如需领取此奖金，请联系我们的在线客服团队。"
    },
    promo4:{
      title:"无限10%充值奖金-适合所有玩家",
      table:{
        header1: "存款金额",
        header2: "獎金金額",
        header3: "起始金额",
        header4: "提现要求",
        header5: "最低提款额",
        header6: "最高提款额",
        withdraw_req: "获胜额 x3"
      },
      tnc1: "最低存款限制为RM10，最高奖金为金额RM50",
      tnc2: "会员每次存款均可尽享此促销活动并且对于所有老虎机均有效",
      tnc3: "提款金额需达到3 倍的（存款 + 獎金金額）",
      tnc4: "提款后所有余额将从玩家的游戏账户删除",
    },
    promo5:{
      title:"25%周末奖金【周六与周日】",
      table:{
        header1: "存款金额",
        header2: "獎金金額",
        header3: "起始金额",
        header4: "提现要求",
        header5: "最低提款额",
        header6: "最高提款额（8x 存款金额）",
        withdraw_req: "获胜额 x3"
      },
      tnc1: "最低存款限制为RM50，最高奖金为金额RM37.5",
      tnc2: "该促销活动奖金适用于 Epicwin & MegaH5 老虎机游戏，会员可在每周六和周日领取一次此促销活动奖金",
      tnc3: "提款金额需达到3倍的（存款 + 獎金金額）",
      tnc4: "提款后所有余额将从玩家的游戏账户删除"
    },
    promo6:{
      title:"每日签到奖金",
      table:{
        header1: "出席率",
        header2: "累计存款金额",
        header3: "奖金金额 ",
        header4: "额外",
        attendance: "30天内累计任何5天",
        accumulated: "{amount} 令吉或以上"
      },
      tnc1: "要领取此奖金，玩家必须在30天内的任意5天累计存款至少RM150。",
      tnc2: "最终奖金将根据奖金表进行分配。",
      tnc3: "确保您的钱包余额低于RM0.50，以领取每日签到奖金。否则，余额将受制于已领取奖金的条款和条件。",
      tnc4: "领取此奖金后，请联系客服以获取10次免费旋转。",
      tnc5: "本次促销的最大提款金额只能进行一次，最低和最高为奖金金额的5倍。",
      tnc6: "此优惠不能与其他存款和促销同时领取，除非另有说明。",
      tnc7: "提款后的任何剩余余额将从玩家账户中移除。",
      tnc8: "可用于所有老虎机游戏。",
    },
    promo7:{
      title:"引荐朋友计划奖金",
      table:{
        header1: "返现奖金",
        header2: "佣金",
        header3: "收到百分比",
        header4: "提现要求",
        details1: "被推荐朋友的存款",
        details2: "下线流水金额",
        details3: "10%"
      },
      tnc1: "通过新推荐的朋友的存款，获得10%的返现或最高可达RM20",
      tnc2: "10% 返现奖金仅在被推荐的朋友无促销存款时有效",
      tnc3: "领取佣金要求为 RM5 或以上",
    },
    promo8:{
      title:"15%周末奖金【周六与周日】",
      table:{
        header1: "存款金额",
        header2: "獎金金額",
        header3: "起始金额",
        header4: "提现要求",
        header5: "最低提款额",
        header6: "最高提款额（8x 存款金额）",
        withdraw_req: "获胜额 x3"
      },
      tnc1: "最低存款限制为RM50，最高奖金为金额RM22.5",
      tnc2: "该促销活动奖金适用于所有老虎机除了 Epicwin & MegaH5 游戏，会员可在每周六和周日领取一次此促销活动奖金",
      tnc3: "提款金额需达到3倍的（存款 + 獎金金額）",
      tnc4: "提款后所有余额将从玩家的游戏账户删除",
    },
    promo9:{
      title: "520 Special",
      table:{
        header1: "累计存款金额",
        header2: "奖金",
        header3: "提款要求",
        header4: "最高提款额",
        header5: "最低提款额",
        header6: "最高提款额",
        withdraw_req: "获胜额 x3"
      },
      tnc1: "活动日期：2024年5月7日 - 20日",
      tnc2: "累积存款达 MYR 520 即可领取 MYR 20 红包",
      tnc3: "5月21日将在 <a href='https://web.telegram.org/k/#@epicwinspin' target='_blank'>EpicWin Telegram 群组 </a> 额外抽出10名幸运玩家赢取 MYR 500 的Epic红包 (领取日期: 5月21日 - 24日)",
      tnc4: "欲领取红包奖励，请联系我们的 LiveChat",
      tnc5: "红包提款要求：获胜额 x3",
      tnc6: "最高提款额：MYR 500",
      tnc7: "仅供玩 EpicWin 和 MegaH5 的游戏",
      tnc8: "红包奖励仅适用于 EpicWin 和 MegaH5 游戏"
    },
    promo10:{
      title: "Birthday Bonus",
      table:{
        header1: "累计存款金额",
        header2: "最低领取额",
        header3: "最高领取额",
        header4: "提款要求",
        header5: "最高提款额",
        detail1: "15 或以上",
        withdraw_req: "获胜额 x5"
      },
      tnc1: "每月累计存款总额达到MYR 150，可在注册日期领取此奖金。",
      tnc2: "此奖金不能与其他奖金叠加使用",
      tnc3: "Epic生日：请参考ID的注册日期，而不是身份证上的生日日期。",
      tnc4: "要领取此奖金，请联系我们的在线客服。",
      tnc5: "每月可领取一次。",
      tnc6: "每年可领取12次。",
      tnc7: "仅限玩 EpicWin 和 MegaH5 游戏。",
      tnc8: "提款要求：最少及最多赢额为x4（MYR 80）。"
    },
    promo11:{
      title: "Live Casino Welcome Bonus 120%",
      tnc1: "玩家只能领取该促销一次。要符合条件，玩家需要最低存入MYR 30，最高可获得RM 120的奖金。",
      tnc2: {
        sub0: "存款和奖金的计算如下所示。",
        sub1: "示例：",
        sub2: "i. 第一笔存款 = MYR 100  ",
        sub3: "ii. 奖金 = 第一笔存款 MYR 100 x 120% = MYR 120",
        sub4: "iii. 流水要求 = (100 + 120) x 30 = MYR 6600"
      },
      tnc3: "此促销的流水要求为30倍，最高可提取金额为（存款 + 奖金）x 10。",
    },
    promo12:{
      title: "Live Casino WEEKDAYS 15% FIRST DEPOSIT BONUS",
      tnc1: "玩家可以在工作日每天领取一次促销。符合条件，玩家需要最少存入MYR 30，并且最高可获得RM 15的奖金。",
      tnc2: {
        sub0: "存款和奖金的计算如下所示。  ",
        sub1: "示例：",
        sub2: "i. 第一笔存款 = MYR 100 ",
        sub3: "ii. 奖金 = 第一笔存款 MYR 100 x 15% = MYR 15",
        sub4: "iii. 流水要求 = (100 + 15) x 20 = MYR 2300"
      },
      tnc3: "此促销的流水要求是20倍，并且最高可提取金额为RM10,000.00。",
    },
    promo13:{
      title: "Live Casino WEEKENDS 25% DEPOSIT BONUS",
      tnc1: "玩家可在周末每天领取一次促销优惠。为了符合资格，玩家需存入最低MYR 50，最高可获得RM 37.50的奖金。",
      tnc2: {
        sub0: "存款和奖金的计算如下所示。 ",
        sub1: "示例： ",
        sub2: "i. 第一笔存款 = MYR 100",
        sub3: "ii. 奖金 = 第一笔存款 MYR 100 x 25% = MYR 25",
        sub4: "iii. 流水要求 = (100 + 25) x 20 = MYR 2,500"
      },
      tnc3: "此促销的流水要求为20倍，最大可提款金额为RM10,000.00。",
      tnc4: "要符合此促销条件，玩家可以在存款页面点击该促销。"
    },
    promo14:{
      title: "11.11 Epic Promo",
      tnc1: "在此优惠活动期间存款总额达 RM1,111，即可立即获得 RM33。11位幸运得主将有机会赢取 RM1,111。获奖名单将在 11月12日于 EpicWin Telegram 群组内公布。（领奖日期：11月12日 - 11月15日）",
      tnc2: "RM33 免费红包提款要求:",
      tnc2_1: "- 存款总额达 RM1,111，即可立即获得 RM33",
      tnc2_2: "- 流水额 x5",
      tnc2_3: "- 可玩所有老虎机游戏。",
      tnc2_4: "- 最大提款限额 x10 (RM330)",
      tnc3: "RM1,111 幸运抽奖提款要求:",
      tnc3_1: "- 存款 RM1,111，总共11位玩家将通过幸运抽奖赢取 RM1,111",
      tnc3_2: "- 流水额 x10",
      tnc3_3: "- 仅限于 EpicWin 和 MegaH5 游戏",
      tnc3_4: "- 最高可提取奖金金额为 RM1,111",
      // tnc5: "此奖金不能与其他奖金合并",
      // tnc6: "红包提款要求：获胜额 x3",
      // tnc7: "仅适用于所有老虎机游戏",
      // tnc8: "要在开始游戏前领取奖金，请联系我们的 LiveChat 支持。"
    },
    promo15:{
      title: "RM50 Comeback Bonus",
      tnc1: "当月存款累计达到RM500，立即获得RM20奖励，下个月再获得RM30奖励",
      tnc2: "提款金额需达到4 倍（獎金金額）",
      tnc3: "最高奖金为金额RM500",
      tnc4: "仅适用于EpicWin游戏",
      tnc5: "如需领取RM20即时奖金，请联系客服",
      tnc6: "如需领取下个月的RM30奖金，请于下个月的1号联系客服",
    },
    promo16:{
      title: "RM500 奥林匹克红包",
      tnc1: "获胜者将根据存款次数和提款金额排行榜进行选择。",
      tnc2: "活动期间：7月22日、7月24日、7月26日、7月29日、7月31日、8月2日、8月5日、8月7日和8月9日。",
      tnc3: "7月22日、7月24日、8月7日和8月9日的获胜者是基于最高存款次数排行榜。",
      tnc4: "7月26日、7月29日、7月31日、8月2日和8月5日的获胜者是基于最高提款金额排行榜。",
      tnc5: "排行榜的前三名可以赢得史诗级奥林匹克红包",
      tnc6: "金奖：MYR 500",
      tnc7: "银奖：MYR 200",
      tnc8: "铜奖：MYR 100",
      tnc9: "获胜者将在每个活动日期的下午6点宣布。",
      tnc10: "最低赢额是x10（最大提款奖金金额）。",
      tnc11: "适用于EpicWin和MegaH5老虎机游戏。",
      tnc12: "可通过在线客服进行领奖。",
    },
    promo17:{
      title: "RM33 红包",
      tnc1: "在第 33 届奥运会优惠活动期间，存款总额达到 MYR 660，即可获得 MYR 33 的红包。",
      tnc2: "优惠活动结束后 10 名幸运玩家将获得MYR 660。获奖者将于 2024年8月8日 在 EpicWin Telegram 群组中宣布。（领取日期：2024年8月8日 - 12日）",
      tnc3: "MYR 33 奖金提款要求：获胜额X4，奖金最大提款金额X10（MYR 330）。",
      tnc4: "仅限玩 EpicWin 和 MegaH5 游戏。"
    },
    cny:{
      title: "CNY 存款 RM 2,888 & 赢取 RM 2,888 红包",
      tnc1: "在农历新年期间（2024年2月10日至2月24日）存款 RM 2,888，有机会赢取高达 RM 2,888 的红包。",
      tnc2: "符合资格的玩家将获得 RM 88 农历新年红包。",
      tnc3: "8名幸运玩家有机会赢取 RM 2,888 的大红包。",
      tnc4: "请联系客服领取您的红包。",
      tnc5: "流水要求：x3",
      tnc6: "最大提款倍数：x10，上限为 RM 2,888。",
      tnc7: "仅适用于 EpicWin 和 MegaH5 游戏。"
    },
    tnc: "规则与条件"
  },
  payment_option: "付款方式",
  payment_list: "接受的付款方式",
  poker:"扑克",

  ref_num_enter: "请录入参考代码",
  register: "注册开户",
  register_now: "立刻注册",
  responsible_gambling: "负责任博彩守则",
  responsible_gaming: "负责任投注守则",
  rebate: "返水",
  rejected: "遭拒",
  result: "赛事结果",
  reward: "奖励优惠",
  rewards: "诸多奖励优惠",
  referral: "邀友",
  referral_desc: {
    one : "每当被推荐的新玩家完成非优惠存款既能赚取高达",
    two: "20令吉",
    three: "的返现金。"
  },
  referral_prefix: "每当你推荐的玩家完成首笔非优惠存款后，就可获得20令吉的返现奖金! 链接: ",
  referral_code: "邀友代码",
  resend: "重发",
  request_again: "请求发送交易识别码 (TAC)",
  reference_number: "参考代码",
  reference_number_tooltips: "请录入参考代码",
  remarks: "备注",
  real_time: "实时",
  recipient_id: "接收者标识",
  review: "评论 | 玩后感言",
  review_title: "你对游戏体验，感受如何？",
  registered_player: "注册玩家总数",
  royalty_level:{
    1: '青铜',
    2: '白银',
    3: '黄金',
    4: '铂金',
    5: '钻石'
  },
  register_title: "现在注册",
  reloadpincode: "充值密码",
  referral_rebate: "推荐返利",
  register_date: "注册日期",
  reset_password: "重置密码",
  remember_me: "记住我?",
  responsible: "理性博彩",

  save: "保存",
  send: "发送",
  social_responsibility: "社会责任",
  status: "状态",
  slots:"老虎机",
  slotgames: "老虎机",
  slot_play: "畅玩",
  slot_games: "老虎机游戏",
  slot_games_mobile: "老虎机手游",
  slot_games_mobile: "老虎机手游",
  signup: "注册开户",
  signupform: {
    first_line: "我已年逾18岁并且同意受平台使用细则与条款所約束 ",
    account_exist: "已经创建投注账户？",
    verification_number: "验证号码",
    problem_assist: "如果你尚未收到讯息鉴别码，请通过即时聊天系统联系我们，予以处理。",
    subscription_confirm: "我有兴趣通过电子邮箱、文字信息或帖子进一步了解更多有关彩金奖励与优惠礼遇活动。",
    account_success_first: "成功创建 ",
    account_success_second: "投注账户。",
    deposit_now: "马上进行存款"
  },
  submit: "提交",
  select_bonus: "请选领彩金奖励",
  spin_again: "旋转多一次",
  success: "成功",
  share_invite_code: "分享你的邀请码",
  share_facebook:"分享至脸书 (Facebook)",
  share_to_friend: "分享给朋友",
  share_referral_reward: "你与友人都可获赏10.00令吉",
  select_deposit: "请选择存款方式",
  survey: {
    1: "游戏体验",
    2: "提现时间",
    3: "客户服务",
    4: "游戏设计",
    5: "推荐朋友"
  },
  single_highest: "最高赔付",
  share_title: "分享链接:",
  settings: "设置",
  subject: "主题",
  search:"搜寻",

  tac_tips: "没有收到TAC代码？请联系<u>在线聊天</u>以获取可用的奖励！",
  tac_tips2: "没有收到TAC代码?",
  time: "时间",
  tutorials: "教程指南",
  type: "类型",
  transfer: "转款",
  transfer_amount: "转款额",
  transaction_history: "交易记录",
  transfer_history: "转款记录",
  tnc: "细则与条款",
  tnc_full: "平台使用细则与条款",
  tnc_accept_reminder: "一旦你在相应方框内打勾，即表示你确认已阅读这些细则和条款，并同意受其所约束。",
  ticket_status: {
    "0": "遭拒",
    "1": "已批"
  },
  tac_code : "交易识别码 (TAC)",
  tac_code_new: "已发送新的交易识别码 (TAC)至您的手机号码",
  topten_WITHDRAWAL: "已提取",
  topten_DEPOSIT:"已存入",
  transaction: "交易",
  tutorial_deposit: "如何通过移动应用进行存款操作",
  tutorial_withdrawal: "如何通过移动应用提交提现申请",
  tutorial_transfer: "如何通过移动应用完成转款操作",
  tutorial_android: "如何下载安卓版移动应用",
  tutorial_ios: "如何下载苹果版 (iOS) 移动应用",
  transfer_fee: "交易费",
  transfer_fee_message: "每笔征收0.20仙",
  thankyou:{
    header: "我们诚挚欢迎每一位加入EPIC大家庭的成员。",
    description: "我们将会赠送一份见面礼给每一位新成员以示感谢"
  },
  total_withdrawal: "每月提款累计次数",
  total_review: "每月点评累计次数",
  top_games: "十大热门游戏",
  topgames_period: "过去 30 天",
  tips:"贴士",
  top30: "前30名存款玩家",

  username: "用户名",
  uh_oh: "呃噢！",
  statement: "报表",
  upload_file: "上传文件",
  upload_file_tooltips: "文件大小不得超过 1mb且必须PNG,JPG或JPEG格式",
  update: "更新",
  update_email: "更新电子邮件",
  update_email_success: "电子邮件更新成功",
  unknown: "未知",

  verification_number: "验证码(TAC)",
  view_transaction_history: "查阅交易过往记录",
  view_transaction: "你可查阅到回溯至90天前的交易记录。",
  verification_no_required: "验证码不得留空",
  phone_no_reminder: "请录入你手机号码最后的四位数。",
  videos: "视频",
  video_link: "影片网址",

  welcome_to: "欢迎到访",
  welcome_1: "由老虎机游戏开发商为你打造首屈 #1指的游戏品牌。",
  welcome_2: "承担付款责任",
  welcome_3: "不止游戏品牌这么简单，我们还是老虎机游戏制作商",
  withdrawal: "提现",
  withdraw_required: "提现额不得留空。",
  withdraw_greater_50: "提现额的具体数值必须超过或等值于50。",
  worth: "价值",
  withdrawal_details: "提现详情",
  withdrawal_details1: "提现次数: 每天5次",
  withdrawal_details2: "提现耗时: 1 分钟: 10, 000令吉",
  withdrawal_details3: "提现耗时: 3 分钟: 100, 000令吉及以上",
  withdrawal_speed: "提款速度",
  withdrawal_epic: "EPIC 提现榜单",
  withdrawal_topten: "排名前10的提现玩家",
  winner_topten: "排名前10的 EPIC传奇大赢家",
  withdrawal_reminder: "提醒：为了避免没收您的余额，如果您正在享受任何促销，请提取全部金额。",

  you_won: "你成功赢得",
  you_have: "你获得",
  withdraw_target_tips: "你必须达成个别优惠活动所规定的指标要求方可申请提现",

  promo_display:{
    OTB: "开户迎新彩金",
    UB: "每日充值送彩金",
    VIPB: "尊享奖金",
    DB: "每日充值送彩金"
  },

  //promotion dropdown
  OTB90: {
    title: "开户迎新彩金",
    coinvalue: "19000",
    cashvalue: "190",
    percentage: "90"
  },
  OTB100:{
    title: "开户迎新彩金",
    coinvalue: "60000",
    cashvalue: "600",
    percentage: "100"
  },
  OTB80:{
    title: "开户迎新彩金",
    coinvalue: "9000",
    cashvalue: "90",
    percentage: "80"
  },
  OTB100D18:{
    title: "开户迎新彩金",
    coinvalue: "3600",
    cashvalue: "36",
    percentage: "100"
  },
  UB10D100:{
    title: "每日充值送彩金",
    coinvalue: "11000",
    cashvalue: "110",
    percentage: "10"
  },
  UB10D200:{
    title: "每日充值送彩金",
    coinvalue: "22000",
    cashvalue: "220",
    percentage: "10",
  },
  UB10D30:{
    title: "每日充值送彩金",
    coinvalue: "3300",
    cashvalue: "33",
    percentage: "10",
  },
  UB10D300:{
    title: "每日充值送彩金",
    coinvalue: "33000",
    cashvalue: "330",
    percentage: "10",
  },
  UB10D50:{
    title: "每日充值送彩金",
    coinvalue: "5500",
    cashvalue: "55",
    percentage: "10",
  },
  UB20D10:{
    title: "每日充值送彩金",
    coinvalue: "1200",
    cashvalue: "12",
    percentage: "20",
  },
  UB20D30:{
    title: "每日充值送彩金",
    coinvalue: "3600",
    cashvalue: "36",
    percentage: "20",
  },
  UB20D50:{
    title: "每日充值送彩金",
    coinvalue: "6000",
    cashvalue: "60",
    percentage: "20",
  },
  UB25D100:{
    title: "每日充值送彩金",
    coinvalue: "12500",
    cashvalue: "125",
    percentage: "25"
  },
  UB25D200: {
    title: "每日充值送彩金",
    coinvalue: "25000",
    cashvalue: "250",
    percentage: "25"
  },
  UB25D300:{
    title: "每日充值送彩金",
    coinvalue: "37500",
    cashvalue: "375",
    percentage: "25"
  },
  VIPB110D1000:{
    title: "尊享奖金",
    coinvalue: "210000",
    cashvalue: "2100",
    percentage: "110"
  },
  VIPB110D3000:{
    title: "尊享奖金",
    coinvalue: "630000",
    cashvalue: "6300",
    percentage: "110"
  },
  VIPB110D5000:{
    title: "尊享奖金",
    coinvalue: "1050000",
    cashvalue: "10500",
    percentage: "110"
  },
  VIPB110D10000:{
    title: "尊享奖金",
    coinvalue: "2100000",
    cashvalue: "21000",
    percentage: "110"
  },
  VIPB200D300:{
    title: "尊享奖金",
    coinvalue: "50000",
    cashvalue: "500",
    percentage: "MYR 200"
  },
  DB20D10:{
    title: "每日充值送彩金",
    coinvalue: "1200",
    cashvalue: "12",
    percentage: "20"
  },

  turnover_downline: "下线流水金额",
  daily_rebate: "每日游戏回馈奖金",
  redeem_ticket: "兑换优惠券",
  redeem: "兑换",
  turnover_amount: "流水金额",
  no_record: "没有任何记录",
  share: "分享",
  total_downline: "共计下线",
  rebate_toclaim: "可申请回馈奖金",
  rebate_total: "共计回款奖金",
  provider: "平台提供方",
  turnover: "游戏流水",
  inbox: "收件箱",
  item: "物件",
  sb_custom: "体育博彩",
  platform: "平台",
  adjustment: "调节",
  referee: "被引荐者",
  game_name: "游戏名称",
  referral_link: "推荐链接 : ",
  trans_time: "交易时间",
};
